import React, { useContext, useEffect, useState } from 'react';
import {Row, Col, Collapse, Navbar, NavbarToggler, Nav, NavItem, Button,
   Dropdown, DropdownMenu, DropdownToggle, DropdownItem} from 'reactstrap';
import styles from './Header.module.scss'
import { Link, useNavigate, NavLink, useLocation } from 'react-router-dom';
import useAuth from '../../utils/hooks/useAuth';
import DesktopMenu from './Menu/DesktopMenu';
import { useToggle } from '../../utils/hooks/useToggle';
import { useLogout } from '../../utils/hooks/useLogout';
import Search from '../Search/Search';
import MobileMenu from './Menu/MobileMenu';
import { Sidebar } from 'primereact/sidebar';
import { AppContext } from '../../globalContext/context';
        

export default function Header(args) {
  const logout = useLogout();
  const { setting } = useContext(AppContext);

  const [isOpen, setIsOpen] = useState(false);
  const [isHomePage, setIsHomePage] = useState();
  const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);

  const [isDropDownOpen, setIsDropDownOpen, toggleIsDropDownOpen] = useToggle(false);
  const [isProfileDropDownOpen, setIsProfileDropDownOpen, toggleIsProfileDropDownOpen] = useToggle(false);
  const [isOffConvas, setIsOffConvas, toggleIsOffConvas] = useToggle(false);

  const location = useLocation();
  const { auth } = useAuth();

  const toggle = () => setIsOpen(!isOpen);

  const navigate = useNavigate();

  const customHeader = (
    <div className="d-flex align-items-center ">
      <Link to='/'>
        {
          setting
            ? <img src={`${!setting ? '/images.png' : `${process.env.REACT_APP_API_URL}${setting.logo}`}`} alt="Letgo or trade" width={'120px'}/>
            : ''
        }
        
      </Link>
    </div>
);


  // show/hide search box
  useEffect(() => {
    if(location.pathname == '/'){
      setIsHomePage(true);
    } else {
      
      setIsHomePage(false);
    }
  },[isHomePage])

  const handleLoginClick = () => {
    navigate('/login');
  }

  const signout = () => {
    logout();
}


  const handleOffCanvas = () => {
    setIsOffConvas(false);
  }
  useEffect(() => {
    setWindowSize([window.innerWidth, window.innerHeight]);
  },[window.innerWidth]);

  return (
    <>
      <div className={`${styles.lgtHeader} py-2 bg-white`}>
        <div className={`container-xxl`}>
          <Row className='align-items-center'>
            <Col md={3} lg={2} className={`order-sm-1 text-sm-start ${isHomePage ? 'order-2 col-6 col-sm-3 text-center' : 'order-1 col-4'}`} >
              <Link to='/'>
                {
                  setting 
                    ? <img src={`${`${process.env.REACT_APP_API_URL}${setting.logo}`}`} alt="Letgo or trade" width={'120px'} className={`${isHomePage ? 'my-2': 'my-2' }`}/>
                    : ''
                }
                
              </Link>
            </Col>
            <Col lg={4} className={`order-sm-2 ${isHomePage ? 'order-3 col-3 col-sm-6 col-md-6' : 'order-2 col-8 col-md-9'}`} >
              {
                windowSize[0] < 1025
                  ? <div className={`${styles.mobileMenu} ${isHomePage ? styles.homepage : styles.notHomepage}`}>
                      <Button
                        onClick={toggleIsOffConvas}
                        className={`fsBig ${styles.mobileIcon} bg-transparent text-color border-0 p-0`}
                      >
                        <i className='bi bi-list'></i>
                      </Button>
                      <Sidebar header={customHeader} visible={isOffConvas} onHide={toggleIsOffConvas} >
                        <MobileMenu auth={auth} onCloseOffCanvas={handleOffCanvas}/>
                      </Sidebar>
                    </div>
                  :  <Navbar {...args} className={`navbar-expand-sm  ${styles.menu}`} >
                      <NavbarToggler onClick={toggle} />
                      <Collapse isOpen={isOpen} navbar>
                      <Nav className="me-auto" navbar >
                        <Dropdown 
                          isOpen={isDropDownOpen} 
                          toggle={toggleIsDropDownOpen} 
                          // onMouseEnter={toggleIsDropDownOpen}
                          // onMouseLeave={toggleIsDropDownOpen}
                          nav 
                          className={`position-static ${styles.hasMegamenu}`}>
                          <DropdownToggle nav>
                            <span>
                              Categories
                              <i className='bi bi-chevron-down ms-1 align-middle' style={{fontSize:'12px'}}></i>
                            </span>
                          </DropdownToggle>
                          <DropdownMenu 
                            container="body" 
                            className={`${styles.DropDownMenu} p-0 `} 
                            style={{height: `${windowSize[1]*3/4}px`}}>
                            <DesktopMenu />
                          </DropdownMenu>
                        </Dropdown>
                        <NavItem>
                          <NavLink className='nav-link' to="/about-us">
                            About us
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink className='nav-link' to={'/contact-us'}>
                            Contact us
                          </NavLink>
                        </NavItem>
                      </Nav>
                      </Collapse>
                    </Navbar>
              }
            </Col>
            <Col lg={6} className={`order-sm-3 ${isHomePage ? 'order-1 col-3 col-sm-3 col-md-3' : 'order-3 col-12 col-md-12 my-2 my-lg-0'}`} >
              <div className={`${isHomePage ? 'justify-content-start' : ''} d-flex justify-content-sm-end align-items-center `}>
                {
                isHomePage
                  ? '' 
                  : <Search />
                }
                <Button
                  onClick={() => navigate(`${auth?.token ? '/dashboard/add-product/' : '/login'}`)} 
                  className={`general-button me-2 ${styles.customMargin} ${styles.listingTitle} d-xs-none`}
                >
                  <i className="bi bi-plus-square me-2 d-xs-none " ></i>
                  <span>
                    Listing
                  </span>
                </Button>
              {
                auth?.token 
                  ? <Dropdown isOpen={isProfileDropDownOpen} toggle={toggleIsProfileDropDownOpen} >
                      <DropdownToggle 
                        className={`${styles.dropDownToggleProfile} p-1 text-color ${styles.customMargin}`}
                      >
                        <i className="bi bi-person me-1" ></i>
                        <i className='bi bi-chevron-down ms-1 align-middle' style={{fontSize:'12px'}}></i>
                      </DropdownToggle>
                      <DropdownMenu
                        className={`${styles.DropDownMenuProfile} p-0 `} 
                        >
                        <DropdownItem
                            onClick={()=> navigate('/dashboard/user-profile')}
                            className={`text-decoration-none text-color ${styles.link} me-4 py-2`}
                            > 
                            <i className="bi bi-person me-1" ></i>
                            {auth.user}
                        </DropdownItem>
                        <DropdownItem
                            onClick={() => navigate(`${auth?.token ? '/dashboard/add-product/' : '/login'}`)}
                            className={`text-decoration-none text-color ${styles.link} me-4 py-2 d-sm-none`}
                          >
                            <i className={`bi bi-plus-square me-2`}></i>
                            Listing
                        </DropdownItem>
                        <DropdownItem
                            onClick={() => navigate('/dashboard/wishlist')}
                            className={`text-decoration-none text-color ${styles.link} me-4 py-2`}

                          >
                            <i className={`bi bi-bookmark me-2`}></i>
                            Wishlist
                        </DropdownItem>
                        <DropdownItem
                            onClick={() => navigate('/dashboard/my-orders')}
                            className={`text-decoration-none text-color ${styles.link} me-4 py-2`}
                          >
                            <i className={`bi bi-bag me-2`}></i>
                            My Order
                        </DropdownItem>
                        <DropdownItem>
                          <div onClick={signout} className='text-danger'>
                            <i className={`bi bi-box-arrow-left me-2`}></i>
                            Logout
                          </div>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  : <Link 
                      to={`${auth?.token ? '' : '/login'}`} 
                      onClick={handleLoginClick}  
                      className={`text-decoration-none text-color fsBig ${styles.link}`}
                    >
                      <i className="bi bi-person me-1" ></i>
                      <span className={`d-xs-none d-sm-none d-xl-inline`}>Login | Register</span>
                    </Link>
                }
              </div>
            </Col>
          </Row>
        </div>
      </div>      
    </>
  )
}
